/* ADD GROUPS */
export const LIST_GROUP_COURSES = "LIST_GROUP_COURSES"
export const LIST_GROUP_COURSES_SUCCESS = "LIST_GROUP_COURSES_SUCCESS"
export const LIST_GROUP_COURSES_CLEAN = "LIST_GROUP_COURSES_CLEAN"
export const LIST_GROUP_COURSES_ERROR = "LIST_GROUP_COURSES_ERROR"
